import './recent.scss';
import 'slick-carousel';

export default () => {
	let $jsRecentSlider = $( '.js-recent-slider' );

	$jsRecentSlider.slick( {
		rows: 0,
		dots: true,
		infinite: true,
		arrows: false,
		slidesToShow: 3,
		swipeToSlide: true,
		touchThreshold: 100,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 2,
					infinite: true,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					infinite: true,

				},
			},
		],
	} );
};
